module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.deleted) ? _c('div', {
    staticClass: "meta-tag-item columns"
  }, [_c('div', {
    staticClass: "centered column delete-column"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.handleDelete
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "url",
      "disabled": !_vm.editMode
    },
    model: {
      value: (_vm.metaTag.url),
      callback: function($$v) {
        _vm.$set(_vm.metaTag, "url", $$v)
      },
      expression: "metaTag.url"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Title",
      "disabled": !_vm.editMode
    },
    model: {
      value: (_vm.metaTag.title),
      callback: function($$v) {
        _vm.$set(_vm.metaTag, "title", $$v)
      },
      expression: "metaTag.title"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Description",
      "disabled": !_vm.editMode
    },
    model: {
      value: (_vm.metaTag.description),
      callback: function($$v) {
        _vm.$set(_vm.metaTag, "description", $$v)
      },
      expression: "metaTag.description"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Keywords",
      "disabled": !_vm.editMode
    },
    model: {
      value: (_vm.metaTag.keywords),
      callback: function($$v) {
        _vm.$set(_vm.metaTag, "keywords", $$v)
      },
      expression: "metaTag.keywords"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "centered column edit edit-column"
  }, [(!_vm.editMode) ? _c('img', {
    staticClass: "edit-icon",
    attrs: {
      "src": "/static/img/icons/edit.svg"
    },
    on: {
      "click": _vm.toggleEdit
    }
  }) : _c('a', {
    staticClass: "button is-info",
    on: {
      "click": _vm.handleUpdateMetaTag
    }
  }, [_vm._v("Сохранить")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-313420d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MetaTags/MetaTagItem.vue
// module id = 923
// module chunks = 0